var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91063 29.5372C12.6306 20.3147 20.3231 12.6222 29.5456 9.90221C36.5581 7.86221 41.4031 8.03221 44.7606 10.5397C48.7981 13.5572 49.2656 18.9972 49.2656 22.8647V33.4472C49.2656 43.9022 44.5056 49.2147 35.1556 49.2147H22.9581C19.1331 49.2147 13.6506 48.7472 10.6331 44.7097C8.04062 41.3947 7.82812 36.5497 9.91063 29.5372Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6355 56.7843C22.7405 55.5093 24.3555 54.7868 26.013 54.7868H41.228C48.708 54.7868 54.7855 48.7093 54.7855 41.2293V26.0143C54.7855 24.3568 55.508 22.7418 56.783 21.6368C58.0155 20.5318 59.7155 20.0218 61.3305 20.2343C71.318 21.5093 80.498 26.9918 86.4905 35.2368C92.5255 43.5243 94.7355 53.6393 92.823 63.7543C90.0605 78.3743 78.373 90.0618 63.7105 92.8243C61.373 93.2918 59.0355 93.5043 56.698 93.5043C49.0055 93.5043 41.568 91.1243 35.2355 86.4918C26.9905 80.4993 21.508 71.3193 20.233 61.3318C20.0205 59.6743 20.5305 58.0168 21.6355 56.7843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.0df90c630cc4d1cb5b204d36f041bc2e.svg";
export { ForwardRef as ReactComponent };